<div id="wrapper" #wrapper>
  <div>
    <div id="left-column">
      <div class="title-div">
        <h1 class="aru-title mb-0">Inspection details</h1>
      </div>
      <div class="col-md-12">
        <form [formGroup]="form" (submit)="submit()">
          <div [ngStyle]="{ flex: 1 }"></div>

          <!--Due Date-->
          <div class="accordion-button active">
            <div style="flex: 1">Due Date</div>
          </div>
          <div class="row col-lg-12 col-md-12" style="margin: 0; background-color: white" formGroupName="locations">
            <!--Due Date-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="col-lg-2 col-md-4 pl-0 titles">Due Date</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-4 col-md-4 form-group">
                    <label>Due Date</label>
                    <input
                      formControlName="dueDate"
                      class="form-control"
                      bsDatepicker
                      [bsConfig]="dateConfig"
                      readonly />
                  </div>
                  <div class="col-lg-2 col-md-2 form-group custom-switch" style="margin-top: 35px">
                    <input
                      type="checkbox"
                      formControlName="forecasted"
                      class="custom-control-input"
                      id="forecasted"
                      disabled />
                    <label class="custom-control-label" for="forecasted">Forecasted</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Customer-->
          <div class="accordion-button active" style="margin-top: 20px">
            <div style="flex: 1">Customer</div>
          </div>
          <div class="row col-lg-12 col-md-12" style="margin: 0; background-color: white">
            <!-- Policy-->
            <div formGroupName="customer" class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px">
              <div class="col-lg-2 col-md-4 pl-0 titles">Policy</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-2 form-group">
                    <label>Product Type</label>
                    <input type="text" class="form-control" formControlName="productType" readonly />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Number</label>
                    <input
                      type="text"
                      class="form-control"
                      [value]="
                        form.get('customer.policyNumber').value +
                        (form.get('customer.customerName').value ? ' | ' + form.get('customer.customerName').value : '')
                      "
                      readonly />
                  </div>
                  <div class="col-lg-4 form-group">
                    <label>Effective Date</label>
                    <input
                      formControlName="policyEffectiveDate"
                      class="form-control"
                      bsDatepicker
                      [bsConfig]="dateConfig"
                      readonly />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 form-group">
                    <label>Policy Group</label>
                    <input type="text" class="form-control" formControlName="policyGroup" readonly />
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!-- Customer-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="customer">
              <div class="col-lg-2 col-md-4 pl-0 titles">Customer</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 form-group">
                    <label>Customer Name</label>
                    <input type="text" class="form-control" formControlName="customerName" readonly />
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!-- Contact-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="customer">
              <div class="col-lg-2 col-md-4 pl-0 titles">Contact</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" formControlName="contactName" readonly />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Email</label>
                    <input type="text" class="form-control" formControlName="contactEmail" readonly />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Phone</label>
                    <input type="text" class="form-control" formControlName="contactPhone" readonly />
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!-- Broker-->
            <div
              class="col-lg-12 col-md-12 pr-0"
              style="display: flex; margin-top: 30px; margin-bottom: 25px"
              formGroupName="customer">
              <div class="col-lg-2 col-md-4 pl-0 titles">Broker</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" formControlName="brokerName" readonly />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Email</label>
                    <input type="text" class="form-control" formControlName="brokerEmail" readonly />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Phone</label>
                    <input type="text" class="form-control" formControlName="brokerPhone" readonly />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Locations-->
          <div class="accordion-button active" style="margin-top: 20px">
            <div style="flex: 1">Locations</div>
          </div>
          <div class="row col-lg-12 col-md-12" style="margin: 0; background-color: white">
            <!-- Inspection Version-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px">
              <div class="col-lg-2 col-md-4 pl-0 titles">Inspection Version</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Version Name</label>
                    <input type="text" class="form-control" [value]="form.get('version')?.value?.name || ''" readonly />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Purpose</label>
                    <input type="text" class="form-control" formControlName="purpose" readonly />
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!-- Items to inspect-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="locations">
              <div class="col-lg-2 col-md-3 pl-0 titles">Items to inspect</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-md-12 form-group">
                    <table class="items-table col-md-12">
                      <thead>
                        <div class="row">
                          <div class="col-md-2 header">Item Type</div>
                          <div class="col-md-2 header">Quantity</div>
                          <div class="col-md-2 header">Custom Names</div>
                          <div class="col-md-6"></div>
                        </div>
                      </thead>
                      <tbody>
                        <div *ngFor="let info of form.get('locations.items').value">
                          <div class="row">
                            <div class="col-md-2 column">{{ info.item?.name }}</div>
                            <div class="col-md-2 column">
                              <input
                                class="form-control"
                                [formControl]="info.quantity"
                                type="number"
                                style="width: 65px"
                                readonly />
                            </div>

                            <div *ngIf="info.customNames" class="col-md-2 column">
                              <div class="custom-control custom-switch">
                                <input
                                  disabled
                                  type="checkbox"
                                  class="custom-control-input"
                                  [formControl]="info.customNames"
                                  [id]="'customSwitch' + (info.id || info.item?.id)" />
                                <label
                                  class="custom-control-label"
                                  [for]="'customSwitch' + (info.id || info.item?.id)"></label>
                              </div>
                            </div>

                            <div class="col-md-6" *ngIf="!info.customNames?.value"></div>

                            <div class="col-md-6 pl-0 column" *ngIf="info.customNames?.value">
                              <ng-container *ngFor="let name of info.namesInputs; index as i">
                                <input
                                  class="form-control"
                                  style="margin-bottom: 10px"
                                  [placeholder]="info?.item?.name + ' #' + (i + 1)"
                                  [formControl]="name"
                                  readonly />
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!--Address-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="locations">
              <div class="col-lg-2 col-md-4 pl-0 titles">Address</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-3 col-md-3 form-group">
                    <label>Location ID</label>
                    <input type="text" class="form-control" formControlName="locationId" readonly />
                  </div>
                  <div class="col-lg-9 col-md-9 form-group">
                    <label>Address</label>
                    <input type="text" class="form-control" formControlName="address" readonly />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>City</label>
                    <input type="text" class="form-control" formControlName="city" readonly />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>State</label>
                    <input type="text" class="form-control" formControlName="state" readonly />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Zip</label>
                    <input type="text" class="form-control" formControlName="zip" readonly />
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!--Map-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="locations">
              <div class="col-lg-2 col-md-4 pl-0 titles">Map</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Latitude</label>
                    <input type="number" class="form-control" formControlName="lat" readonly />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Longitude</label>
                    <input type="number" class="form-control" formControlName="lng" readonly />
                  </div>
                  <div class="col-md-12">
                    <div style="width: 100%; height: 400px; margin-bottom: 20px">
                      <app-mapbox #mapbox (load)="setMap($event)" (styleLoaded)="styleLoaded()"></app-mapbox>
                      <button type="button" class="update-map btn" (click)="updateMapFromForm()">Reset Map</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Assignments-->
          <div id="assignments-section" class="accordion-button active" style="margin-top: 20px">
            <div style="flex: 1">Assignments</div>
          </div>
          <div class="row col-lg-12 col-md-12" style="margin: 0; background-color: white">
            <!--Inspector-->
            <div
              class="col-lg-12 col-md-12 pr-0"
              style="display: flex; margin-top: 30px; margin-bottom: 25px"
              formGroupName="vendor">
              <div class="col-lg-2 col-md-3 pl-0 titles">Inspector</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 col-md-12 form-group">
                    <label>Assign to inspector</label>
                    <ng-select
                      [items]="inspectorDataSource"
                      bindLabel="name"
                      [trackByFn]="inspectorTrackByFn"
                      (change)="onInspectorSelect($event)"
                      formControlName="inspector"
                      (focusout)="handleDropdownClose()"
                      (clear)="clearInspector()">
                      <ng-template ng-option-tmp let-item="item">
                        <div class="d-flex justify-content-between" *ngIf="item && item.distanceInMiles">
                          <span>
                            {{ item.name }}
                            <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                          </span>
                          <span>
                            <small class="pr-6" *ngIf="item.distanceInMiles"
                              >Open Inspections: {{ item.assignmentMadeCount }}</small
                            >
                          </span>
                        </div>
                      </ng-template>

                      <ng-template ng-label-tmp let-item="item">
                        <div>
                          {{ item.name }}
                          <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                        </div>
                      </ng-template>

                      <ng-template ng-footer-tmp>
                        <a *ngIf="!viewMoreClicked" (click)="viewMoreInspectors()" class="view-more-link">View more</a>
                      </ng-template>
                      <ng-template ng-not-found> No inspectors found. </ng-template>
                    </ng-select>
                    <p class="text-danger" *ngIf="inspectorMismatch">
                      This Inspector doesn't match the inspection's product type. Proceed anyway?
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Buttons-->
          <div class="row col-lg-12 col-md-12">
            <!-- Save-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="row" *ngIf="showSaveButton">
                <div class="form-group">
                  <button class="btn aru btn-primary" [disabled]="!form.valid">Save</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="right-column" *ngIf="inspection.id">
      <!-- Upper Section - Fixed Height -->
      <div class="right-panel-info">
        <div class="title-div">
          <b>More information</b>
        </div>
        <p style="margin-left: 20px; margin-bottom: 0">
          Policy Number: <b>{{ inspection.policyNumber }}</b>
        </p>
        <p style="margin-left: 20px; margin-bottom: 0">
          Customer Name: <b>{{ inspection.customerName }}</b>
        </p>
        <p style="margin-left: 20px; margin-bottom: 0">
          Address: <b>{{ inspection.address }}, {{ inspection.city }}, {{ inspection.state }} {{ inspection.zip }}</b>
        </p>
        <p *ngIf="inspection.dueDate" style="margin-left: 20px; margin-bottom: 0">
          Due Date: <b>{{ dateAsString(inspection.dueDate) }}</b>
        </p>
        <div class="row" style="margin: 20px 0 0 20px">
          <div class="col-md-12 pl-0">
            Status:
            <span
              style="font-weight: bold"
              [ngStyle]="{ color: statusAsText(inspection) === 'Accepted' ? '#4dbd74' : '#2763CD' }"
              >{{ statusAsText(inspection) }}
              <span *ngIf="inspection.archived" style="color: #dc3e3e">(Archived)</span>
              <span class="badge badge-pill badge-danger" *ngIf="inspection.status == InspectionStatus.INVALID_SYNC"
                >Invalid</span
              >
            </span>
            <p *ngIf="statusAsText(inspection) === 'Ready to be assigned'" class="status-info">
              for inspection on {{ dateAsString(inspection.dueDate) }}
            </p>

            <p *ngIf="statusAsText(inspection) === 'Assignment made'" class="status-info">
              to {{ inspection.vendor?.name }} {{ inspection.inspector ? '/ ' + inspection.inspector.name : '' }} for
              inspection on {{ dateAsString(inspection.dueDate) }}
            </p>

            <p *ngIf="statusAsText(inspection) === 'Waiting'" class="status-info">
              until {{ dateAsString(inspection.dueDate) }}
              <span *ngIf="inspection.vendor">
                to be completed by {{ inspection.vendor?.name }}
                {{ inspection.inspector ? '/ ' + inspection.inspector.name : '' }}
              </span>
            </p>

            <p *ngIf="statusAsText(inspection) === 'Due completion'" class="status-info">
              <span *ngIf="inspection?.lastSynced">
                Sync in progress since {{ dateAsString(inspection.lastSynced) }}
                <br />
              </span>
              by {{ inspection.vendor?.name }} {{ inspection.inspector ? '/ ' + inspection.inspector.name : '' }} since
              {{ dateAsString(inspection.dueDate) }}
            </p>

            <p *ngIf="statusAsText(inspection) === 'Completed and needs review'" class="status-info">
              on {{ dateAsString(inspection.completed) }}, {{ daysSince(inspection.completed) }} days since completed
            </p>

            <p *ngIf="statusAsText(inspection) === 'Rejected'" class="status-info">
              on {{ dateAsString(inspection.rejected) }}, {{ daysSince(inspection.rejected) }} days ago
            </p>

            <p *ngIf="statusAsText(inspection) === 'Accepted'" class="status-info">
              on {{ dateAsString(inspection.accepted) }}, {{ daysSince(inspection.accepted) }} days ago
            </p>

            <p *ngIf="statusAsText(inspection) === 'Completed'" class="status-info">
              on {{ dateAsString(inspection.paid) }}, {{ daysSince(inspection.paid) }} days ago
            </p>
          </div>
        </div>

        <!-- Action Buttons - Fixed height for consistent layout -->
        <div class="row action-buttons-section" style="margin: 20px 0 0 20px">
          <div class="col-md-12 pl-0">
            <!-- Assign Inspector for Ready to be assigned -->
            <div *ngIf="!this.form.get('vendor.inspector').value">
              <button
                class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0"
                style="width: 175px; padding: 12px 33px"
                (click)="scrollToAssignments()">
                Assign inspector
              </button>
            </div>

            <!-- Send Reminder for Assignment Made or Due Completion -->
            <div
              *ngIf="
                this.form.get('vendor.inspector').value &&
                (statusAsText(inspection) === 'Assignment made' || statusAsText(inspection) === 'Due completion')
              ">
              <button
                class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0"
                style="width: 175px"
                (click)="sendReminderDue()">
                Send reminder
              </button>
            </div>

            <!-- Send Reminder for Rejected -->
            <div *ngIf="statusAsText(inspection) === 'Rejected'">
              <button
                class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0"
                style="width: 175px"
                (click)="sendReminderRejected()">
                Send reminder
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Notes Section -->
      <div class="right-panel-notes">
        <div class="row" style="margin-top: 3rem">
          <div class="col-md-12">
            <!--Tab Navigation - Single Notes Tab-->
            <div class="notes-changes-tabs">
              <div class="tab-item selected">
                <div class="tab-label">Notes</div>
              </div>
            </div>

            <!--Tab Content-->
            <div class="tab-content">
              <div class="row col-lg-12 col-md-12 pl-0 pr-0" style="margin: 0">
                <div class="col-lg-12 col-md-12 pr-0 pl-0">
                  <div forScroll>
                    <app-inspection-notes
                      #inspectionNotes
                      [showFilter]="false"
                      [vendorMode]="true"
                      (noteClicked)="handleNoteClicked()"></app-inspection-notes>
                  </div>
                </div>
              </div>
            </div>

            <!-- Separator with shadow -->
            <div style="position: fixed; top: 93vh; width: 100%; background: white">
              <div class="content-separator"></div>
              <div class="add-note-button" (click)="showAddNoteModal()">
                <div class="button-text">Add Scheduling Note</div>
                <img src="assets/img/plus.svg" class="plus-icon" alt="plus" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="right-column-empty" *ngIf="!inspection.id"></div>
  </div>
</div>

<!-- Add Scheduling Note Modal -->
<app-add-scheduling-note
  *ngIf="showModal"
  [inspectionId]="inspection.id"
  (closeModal)="hideAddNoteModal()"
  (noteCreated)="onNoteCreated($event)">
</app-add-scheduling-note>
